// extracted by mini-css-extract-plugin
export default {"alertContainer":"WinAlert_alertContainer__tDuxF","winAlert":"WinAlert_winAlert__o1Qr5","confettiContainer":"WinAlert_confettiContainer__EAQkn"};